import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useStore } from 'effector-react';

import { $markeredMixes } from '@/modules/mixing/store/recipes.store';
import { $topRecipesLoading } from '@/widgets/recipe/model';
import { MixItem } from '../../../../../common/components/mix-item';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import { IExclusiveRecipe } from '@/widgets/recipe/types';
import styles from './index.module.sass';

export const MixesList = ({
  selectRecipeFoo,
  mixesList,
}: {
  selectRecipeFoo: (id: number) => void;
  mixesList: IExclusiveRecipe[] | [];
}) => {
  // const topRecipes = useStore($topRecipesForWarehouse);
  const [searchParams] = useSearchParams();
  const preMarkeredMixes = (() => {
    let items: any = searchParams.get('markered_bags');
    items = items?.split(',');
    items = items?.map((item: string) => +item);
    if (items?.length > 0) return items;
  })();
  const loadingData = useStore($topRecipesLoading);
  const markeredMixes = preMarkeredMixes ? preMarkeredMixes : useStore($markeredMixes);

  const scrollToItem = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  useEffect(() => {
    if (mixesList && mixesList?.length > 0) {
      setTimeout(() => {
        if (markeredMixes && Array.isArray(markeredMixes)) {
          return scrollToItem(markeredMixes?.[0]);
        }
      }, 1000);
    }
  }, [mixesList]);

  //console.log(mixesList)

  return (
    <div className={styles.root}>
      {!loadingData.loading ? (
        mixesList?.length > 0 ? (
          mixesList?.map((item, i) => (
            <MixItem
              key={item.id}
              markered={!!markeredMixes?.includes(item.id)}
              params={
                Array.isArray(item.mixed_properties) ? item.mixed_properties : undefined
              }
              mode="mix"
              buyer={item.buyer_company}
              idx={item.id}
              onClick={() => selectRecipeFoo(item.id)}
              sort={item.sort}
              type={item.type}
              weight={item?.all_weight}
              components={item.components}
              price={item?.price_all}
              nettPrice={item.price_netto}
              profit={item?.mixing_profit}
              distance={item?.distance}
              pricePerTon={item?.price_per_ton}
              offerHumidity={item?.offer_humidity}
              logitPrice={item?.price_logistic}
              status={item?.status}
              hasTrade={item.trade_id}
              tradeClass={String(item.class_n)}
            />
          ))
        ) : (
          <div className={styles.filler}>
            {' '}
            <span>рецепты не найдены</span>
          </div>
        )
      ) : (
        <UniversalLoader error={loadingData.error} />
      )}
    </div>
  );
};
